module.exports = __webpack_public_path__ + "img/gift.26647983.png";